import React, { useState } from 'react'
import Icon from 'components/elements/Icon'

import { useAppSelector } from 'redux/hooks'

import AddCardsModal from 'components/collectionV2/addCards/Modal'
import NumberOfResults from 'components/collectionV2/NumberOfResults'
import ViewsAndSorts from 'components/collectionV2/controls/Content/subcontrols/ViewsAndSorts'
import CollectionFilter from 'components/collectionV2/controls/Content/subcontrols/CollectionFilter'
import ColumnControls from 'components/collectionV2/views/Text/ColumnControls'
import ImageSizeControls from 'components/collectionV2/views/Image/ImageSizeControls'
import ActiveFilters from 'components/collectionV2/controls/Content/subcontrols/ActiveFilters'

import styles from './content.module.scss'

type Props = {}

const Controls = ({}: Props) => {
  const view = useAppSelector(state => state.collectionV2.view)
  const viewingLabels = useAppSelector(state => state.collectionV2.viewingLabels)
  const ownsCollection = useAppSelector(state => state.collectionV2.ownsCollection)

  const [addCardModalOpen, setAddCardModalOpen] = useState(false)

  return (
    <div className={styles.container}>
      <div className={`${styles.controls} ${!ownsCollection ? styles.twoColumnLayout : ''}`}>
        {ownsCollection && (
          <button className={styles.addCardButton} onClick={() => setAddCardModalOpen(true)}>
            <Icon name="add circle" /> Add Card
          </button>
        )}

        <ViewsAndSorts />

        <CollectionFilter />
      </div>

      <div className={styles.secondaryControls}>
        <NumberOfResults />

        {view === 'text' && !viewingLabels && <ColumnControls />}
        {view === 'image' && !viewingLabels && <ImageSizeControls />}
      </div>

      <ActiveFilters />

      <AddCardsModal open={addCardModalOpen} onClose={() => setAddCardModalOpen(false)} />
    </div>
  )
}

export default Controls
